<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="videoCategory.id === null">{{ 'NEWVIDEOCATEGORY' | translate }}</span>
            <span *ngIf="videoCategory.id !== null">{{ 'EDITVIDEOCATEGORY' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="videoCategoryForm" id="videoCategoryForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="videoCategoryForm" >
            <input type="hidden" name="id" id="videoCategoryId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="videoCategoryName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="videoCategoryName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="videoCategoryForm.controls['name'].invalid && (videoCategoryForm.controls['name'].dirty || videoCategoryForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="videoCategoryForm.controls['name'].errors !== null">
                  <div *ngIf="videoCategoryForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="videoCategoryNameAr" formControlName="nameAr" type="text" pInputText [required]="false"> 
                      <label for="videoCategoryNameAr" class="">{{ 'NAMEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="videoCategoryNameFr" formControlName="nameFr" type="text" pInputText [required]="false"> 
                      <label for="videoCategoryNameFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="videoCategorySlug" formControlName="slug" type="text" pInputText [required]="true"> 
                      <label for="videoCategorySlug" class="req">{{ 'SLUG' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="videoCategoryForm.controls['slug'].invalid && (videoCategoryForm.controls['slug'].dirty || videoCategoryForm.controls['slug'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="videoCategoryForm.controls['slug'].errors !== null">
                  <div *ngIf="videoCategoryForm.controls['slug'].errors.required">
                   {{ 'SLUGREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="videoCategorySlugAr" formControlName="slugAr" type="text" pInputText [required]="false"> 
                      <label for="videoCategorySlugAr" class="">{{ 'SLUGAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="videoCategorySlugFr" formControlName="slugFr" type="text" pInputText [required]="false"> 
                      <label for="videoCategorySlugFr" class="">{{ 'SLUGFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="videoCategoryPicture" formControlName="picture" type="text" pInputText [required]="false"> 
                      <label for="videoCategoryPicture" class="">{{ 'PICTURE' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('picture')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-info-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="videoCategoryDescription" formControlName="description" type="text" pInputText [required]="true"> 
                      <label for="videoCategoryDescription" class="req">{{ 'DESCRIPTION' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="videoCategoryForm.controls['description'].invalid && (videoCategoryForm.controls['description'].dirty || videoCategoryForm.controls['description'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="videoCategoryForm.controls['description'].errors !== null">
                  <div *ngIf="videoCategoryForm.controls['description'].errors.required">
                   {{ 'DESCRIPTIONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-align-justify"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="videoCategoryDescriptionAr" formControlName="descriptionAr" type="text" pInputText [required]="false"> 
                      <label for="videoCategoryDescriptionAr" class="">{{ 'DESCRIPTIONAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-align-justify"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="videoCategoryDescriptionFr" formControlName="descriptionFr" type="text" pInputText [required]="false"> 
                      <label for="videoCategoryDescriptionFr" class="">{{ 'DESCRIPTIONFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="videoCategoryParentId" [autoDisplayFirst]="false" formControlName="parent" [options]="videoCategoriesColumnsService.videoCategories" optionValue="id" optionLabel="name" [required]="false" [filter]="true"></p-dropdown>
                      <label for="videoCategoryParentId" class="">{{ 'PARENT' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-file-video"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="videoCategoryVideoTypeId" [autoDisplayFirst]="false" formControlName="videoType" [options]="videoCategoriesColumnsService.videoTypes" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="videoCategoryVideoTypeId" class="req">{{ 'VIDEOTYPE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="videoCategoryForm.controls['videoType'].invalid && (videoCategoryForm.controls['videoType'].dirty || videoCategoryForm.controls['videoType'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="videoCategoryForm.controls['videoType'].errors !== null">
                  <div *ngIf="videoCategoryForm.controls['videoType'].errors.required">
                   {{ 'VIDEOTYPEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-list-ol"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="videoCategoryOrdering" formControlName="ordering" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="videoCategoryOrdering" class="">{{ 'ORDERING' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_PUBLISHER') === -1" >
                  <label for="videoCategoryStatus" class="req">{{ 'STATUS' | translate }}</label>
                  <div class="p-formgroup-inline">
                    <div class="p-field-checkbox" *ngFor="let option of videoCategoriesColumnsService.statusesOptions; let i = index">
                      <p-radioButton inputId="videoCategoryStatus_{{ i }}" formControlName="status" name="status" [value]="option.value"></p-radioButton>
                      <label for="videoCategoryStatus_{{ i }}">{{ option.label | translate }}</label>
                    </div>
                  </div>
                </div>
                <div *ngIf="videoCategoryForm.controls['status'].invalid && (videoCategoryForm.controls['status'].dirty || videoCategoryForm.controls['status'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="videoCategoryForm.controls['status'].errors !== null">
                  <div *ngIf="videoCategoryForm.controls['status'].errors.required">
                   {{ 'STATUSREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKVIDEOCATEGORIES' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="videoCategory.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!videoCategoryForm.valid || disableSubmit"> <!--  [disabled]="videoCategoryForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!videoCategoryForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

